import { type FeatureRequest, FieldDataType, type FieldRequest } from '../types'

export const mapNullableFormFieldsToFeatureRequest = (formFeatureRequest: FeatureRequest<null>): FeatureRequest<undefined> => ({
  ...formFeatureRequest,
  data: {
    fields: formFeatureRequest.data.fields.map<FieldRequest<undefined>>((field) => {
      switch (field.type) {
        case FieldDataType.BOOLEAN: {
          return {
            type: field.type,
            name: field.name,
            value: field.value ?? undefined,
          }
        }

        case FieldDataType.INTEGER: {
          return {
            type: field.type,
            name: field.name,
            value: field.value ?? undefined,
          }
        }

        case FieldDataType.ENUM: {
          return {
            type: field.type,
            name: field.name,
            value: field.value ?? undefined,
          }
        }
      }
    }),
  },
})
